import { render, staticRenderFns } from "./AbsentPeriodModal.vue?vue&type=template&id=2a00f84c&scoped=true&"
import script from "./AbsentPeriodModal.vue?vue&type=script&lang=js&"
export * from "./AbsentPeriodModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a00f84c",
  null
  
)

export default component.exports